import { TrashIcon } from '@heroicons/react/24/outline'
import React from 'react'

const DboyList = ({ deliverytData, deleteOrder }) => {
	console.log(deliverytData)
	return (
		<div className='mt-5 overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
			<div className='overflow-x-auto'>
				<table className='min-w-full border-separate border-spacing-0'>
					<thead>
						<tr className='bg-[#fffaf6]'>
							<th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Delivery Boy</th>
							<th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Created Date</th>
							<th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Order Numbers</th>
							<th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Vehicle No</th>
							<th className='border-b border-slate-200 px-5 py-4 text-left text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Status</th>
							<th className='border-b border-slate-200 px-5 py-4 text-center text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>Action</th>
						</tr>
					</thead>
					<tbody>
						{deliverytData?.length ? deliverytData.map((item) => {
							const createdDate = item?.createdAt
								? (typeof item.createdAt === 'object' && item.createdAt.toDate
									? item.createdAt.toDate()
									: new Date(item.createdAt))
								: null

							return (
								<tr key={item?.id} className='transition-colors hover:bg-slate-50/70'>
									<td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyBold] text-slate-900'>{item?.user?.name || '-'}</td>
									<td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>
										{createdDate ? `${createdDate.toDateString()}, ${createdDate.toLocaleTimeString()}` : 'N/A'}
									</td>
									<td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>
										<div className='max-w-[320px] whitespace-normal break-words'>{item?.lrNumber?.length ? item.lrNumber.join(', ') : '-'}</div>
									</td>
									<td className='border-b border-slate-100 px-5 py-4 text-[13px] font-[GilroyMedium] text-slate-700'>{item?.vehicleNo || '-'}</td>
									<td className='border-b border-slate-100 px-5 py-4 text-[13px]'>
										<span className='inline-flex rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-[GilroyMedium] capitalize text-slate-700'>
											{item?.deliveryBoyStatus || 'Pending'}
										</span>
									</td>
									<td className='border-b border-slate-100 px-5 py-4 text-center'>
										<button
											type='button'
											onClick={() => deleteOrder(item?.id)}
											className='rounded-full p-2 text-red-600 transition-colors hover:bg-red-50'
										>
											<TrashIcon className='h-4 w-4' />
										</button>
									</td>
								</tr>
							)
						}) : (
							<tr>
								<td colSpan={6} className='px-5 py-16 text-center'>
									<p className='text-base font-[GilroyMedium] text-slate-500'>No delivery assignments found</p>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	)
}

export default DboyList
